import { useStyles } from '@crm/features/billing/styles'
import { useLocales } from '@shared/locales'
import { Button, Card, Flex, Form, Input } from 'antd'
import { AddCircle, Trash } from 'iconsax-react'

type Props = {
  setFieldValue(name: (string | number)[], value: number | string): void
}
export const AmountField = ({ setFieldValue }: Props) => {
  const { t } = useLocales()

  const { styles } = useStyles()

  return (
    <Card
      size="small"
      title={t('billing.amount')}
      className={styles.amountField}
    >
      <Form.List
        name="amounts"
        initialValue={[
          {
            title: null,
            quantity: null,
            amount: null,
            tax: null,
            total: null
          }
        ]}
      >
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name }) => (
              <Flex gap="small" key={key}>
                <Form.Item
                  label={t(`billing.title`)}
                  name={[name, 'title']}
                  required
                  rules={[
                    {
                      required: true,
                      message: t('billing.title_required')
                    }
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
                <Form.Item
                  label={t(`billing.quantity`)}
                  name={[name, 'quantity']}
                  required
                  rules={[
                    {
                      required: true,
                      message: t('billing.amount_quantity_required')
                    }
                  ]}
                >
                  <Input type="number" min={0} />
                </Form.Item>
                <Form.Item
                  label={t(`billing.amount`)}
                  name={[name, 'amount']}
                  required
                  rules={[
                    {
                      required: true,
                      message: t('billing.amount_required')
                    }
                  ]}
                >
                  <Input type="number" min={0} />
                </Form.Item>
                <Form.Item label={t(`billing.tax`)} name={[name, 'tax']}>
                  <Input type="number" min={0} />
                </Form.Item>
                <Form.Item
                  shouldUpdate={(prevVal, currentVal) => {
                    if (
                      prevVal?.amounts?.[name]?.quantity !==
                        currentVal?.amounts?.[name]?.quantity ||
                      prevVal?.amounts?.[name]?.amount !==
                        currentVal?.amounts?.[name]?.amount ||
                      prevVal?.amounts?.[name]?.tax !==
                        currentVal?.amounts?.[name]?.tax
                    ) {
                      setFieldValue(
                        ['amounts', name, 'total'],
                        Number(currentVal?.amounts?.[name]?.quantity || 1) *
                          Number(currentVal?.amounts?.[name]?.amount || 0) +
                          Number(currentVal?.amounts?.[name]?.tax || 0)
                      )
                    }
                    return false
                  }}
                >
                  {() => {
                    return (
                      <Form.Item
                        required
                        label={t(`billing.total`)}
                        name={[name, 'total']}
                        rules={[
                          {
                            required: true,
                            message: t('billing.amount_total_required')
                          }
                        ]}
                      >
                        <Input disabled type="number" />
                      </Form.Item>
                    )
                  }}
                </Form.Item>

                <Form.Item label=" ">
                  <Button
                    type="text"
                    onClick={() => remove(name)}
                    icon={<Trash size={20} />}
                    disabled={fields.length === 1}
                  />
                </Form.Item>
              </Flex>
            ))}

            <Button type="link" onClick={add} icon={<AddCircle size={20} />}>
              {t('buttons.add')}
            </Button>
          </>
        )}
      </Form.List>
    </Card>
  )
}
